class DefaultTimeProvider {
  async sleepMs(ms: number): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, ms));
  }

  now(): Date {
    return new Date(Date.now());
  }
}

export default DefaultTimeProvider;
